import Text from "app/styles/Text";
import { ReactComponent as CloseIcon } from "app/assets/icons/close-small.svg";

interface Props {
  message?: string;
  onClose: () => void;
}
export default function ErrorMessage({
  message = "An error occurred",
  onClose,
}: Props) {
  return (
    <div tw="w-[480px] max-w-full h-[52px] flex items-center justify-between px-[16px] border border-error70 bg-error10 rounded-[4px]">
      <Text tw="text-error90" as="div">
        {message}
      </Text>

      <button aria-label="close" type="button" onClick={onClose}>
        <CloseIcon />
      </button>
    </div>
  );
}
